import { render, staticRenderFns } from "./Paketlemeislemi.vue?vue&type=template&id=29efcc2b&"
import script from "./Paketlemeislemi.vue?vue&type=script&lang=js&"
export * from "./Paketlemeislemi.vue?vue&type=script&lang=js&"
import style0 from "./Paketlemeislemi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports